// import axios from "axios";
import axios from "@/setup/axios-setup";
import {config} from "@/utils/upload";
import {error} from '@/utils/notification';
import {getECode, getRStage, getToken} from "@/utils/auth-data";

export async function uploadAvatar(context, payload){
  context.commit('setProcessing', true);
  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('file1', payload.file1);
  formData.append('ext', payload.file.name.substring([payload.file.name.lastIndexOf('.') + 1]));
  formData.append('timestamp', payload.file.lastModified);
  formData.append('operationName', payload.operationName);
  formData.append('stage', getRStage);
  formData.append('entity', getECode);
  formData.append('authorization', getToken);
  formData.append('app', 'admin');

  try {
    const result = await axios({
      url: config.url.uploadAvatar,
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: formData,
    });

    context.commit('setSuccess', null);
    const {data} = await result;

    return data;
  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }

}
